import { useRecordContext } from 'react-admin';

type CropsFieldProps = {
  source?: string;
  cropsMap?: Map<string, string>;
};

export const CropsField = ({ source = 'crops', cropsMap }: CropsFieldProps) => {
  const record = useRecordContext();

  if (!record) return null;

  if (record.allCrops) {
    return <small>ALL CROPS</small>;
  }

  const ids = record[source] || [];

  const names = ids
    .map((id: string) => cropsMap?.get(`${id}`))
    .filter(Boolean)
    .join(', ');

  return <span>{names}</span>;
};
